<template>
    <main class="page__content">
        <div class="plain-content">
            <div class="plain-content__inner">
                <div class="plain-content__header">
                    <h1>Häufig gestellte Fragen</h1>
                </div>
                <div class="plain-content__body">
                    <p>Die Stadtwerke Velbert GmbH, Kettwiger Straße 2, 42549 Velbert ist Initiator der Spendenplattform Velbert zeigt Herz</p>
                    <p>Mit den Förderherzen der Stadtwerke Velbert werden kleine soziale bzw. gemeinnützige Projekte in Velbert unterstützt. Die Stadtwerke Velbert GmbH stellt für diese Aktion einen speziellen Spendentopf zur Verfügung.</p>
                    <p>Unser regionales Spendenportal bietet sozialen Initiativen in Velbert eine Plattform, sich und ihre Anliegen prominent zu präsentieren. Wir stehen zu unserer gesellschaftlichen Verantwortung für die Region. Deshalb setzen wir uns mit unterschiedlichen Projekten für das Gemeinwesen ein.</p>
                    <p>Im Folgenden beantworten wir Ihre Fragen.</p>
                    <collapsible>
                        <h2 class="h5">Was sind der Spendencode und die Förderherzen der Aktion Velbert zeigt Herz?</h2>
                        <div slot="body">
                            <p>
                                Unsere Herzen sind lediglich eine fiktive Währung. Jeweils vier Herzen
                                verbergen sich hinter einem Spendencode.
                            </p>
                            <p>
                                Ein Spendencode ist 2 Euro wert, womit jedes Förderherz einen Gegenwert von
                                50 Cent besitzt.
                            </p>
                            <p>
                                Mit unseren Förderherzen können Sie auf unserer Website
                                velbert-zeigt-herz.de soziale Projekte, die dem Gemeinwohl Velberts dienen,
                                unterstützen. Mit der Verteilung der Herzen entscheiden Sie, welche
                                Projekte die Stadtwerke Velbert mit wie viel Spenden unterstützen sollen.
                            </p>
                        </div>
                    </collapsible>
                    <h3>Projekt entdecken und Herzen Spenden
                        <br>
                        <em>Sie möchten ein Projekt mit ihren Förderherzen unterstützen?</em>
                    </h3>
                    <collapsible>
                        <h2 class="h5">Wie bekomme ich Spendencodes und damit Förderherzen für die Aktion?</h2>
                        <div slot="body">
                            <p>Einen Spendencode können Sie ganz einfach <router-link :to="{name: 'RequestCode'}">hier</router-link> anfordern. Diesen können Sie dann unter <a href="https://www.velbert-zeigt-herz.de/" target="_blank">velbert-zeigt-herz.de</a> für das Projekt oder die Projekte Ihrer Wahl einlösen. Sie haben die Möglichkeit, dies einmal pro Monat zu tun. Darüber hinaus gibt es Kärtchen mit Spendencodes. Deren Verteilung kündigen wir in der Regel auf der Facebookseite der Stadtwerke Velbert an.</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Wie lange sind die Spendencodes und damit meine Förderherzen gültig?</h2>
                        <div slot="body">
                            <p>Die Spendencodes sind 12 Monate gültig.</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Wie kann ich meine Spendencodes einlösen?</h2>
                        <div slot="body">
                            <p>
                                Nachdem Sie im grünen Bereich unter
                                <em>Hier Spendencodes einlösen</em>
                                Ihren 8-stelligen Spendencode eingegeben haben, sind für Sie auf der
                                Website ähnlich wie in einem Warenkorb automatisch 4 Förderherzen
                                verfügbar. Wenn Sie nun durch die Projekte stöbern, können Sie diese 4
                                Herzen beliebig verteilen. Sie können Ihre Herzen einzeln oder zu mehreren
                                an ein Projekt vergeben. Wählen Sie dazu auf der Projektübersichtsseite ein
                                Projekt aus und klicken Sie auf
                                <em>zum Projekt</em>. Damit gelangen Sie
                                auf der Detailseite des Projekts. Dort haben Sie die Möglichkeit, die
                                Anzahl Ihrer Förderherzen einzutragen. Klicken Sie
                                <em>Spenden</em>und
                                Ihre Herzen werden dem Projekt gutgeschrieben.
                            </p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Muss ich mich speziell registrieren, um meinen Spendencode einzulösen und die Förderherzen verteilen zu können?</h2>
                        <div slot="body">
                            <p>Nein. Sie geben lediglich Ihren Spendencode ein und erhalten dann automatisch Ihre 4 Förderherzen, über die Sie frei verfügen können. Eine Registrierung ist nicht notwendig.</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Wenn ich mit einem Spendencode nicht alle 4 Herzen verteile, was passiert mit den übrig gebliebenen?</h2>
                        <div slot="body">
                            <p>Sie brauchen nicht alle 4 Herzen auf einmal einzulösen. Sie können unsere Seite www.velbert-zeigt-herz.de jederzeit noch einmal besuchen, geben dann Ihren Spendencode nochmals ein und können dann die verbleibenden Herzen spenden.</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Welche Projekte kann ich mit Förderherzen unterstützen?</h2>
                        <div slot="body">
                            <p>Mit Ihren Förderherzen der
                                <em>Aktion Velbert zeigt Herz</em>können Sie alle Projekte unterstützen, die bisher noch nicht ihr Spendenziel erreicht haben.
                            </p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Kann ich auch mehrere Projekte mit meinen Förderherzen unterstützen?</h2>
                        <div slot="body">
                            <p>Ja. Hinter einem Spendencode verbergen sich 4 Förderherzen. Diese können Sie frei verteilen, maximal können Sie also 4 Projekte mit je einem Förderherz (= 50 Cent) unterstützen.</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Kann ich Projekte mit meinem privaten Geld unterstützen?</h2>
                        <div slot="body">
                            <p>Optional kann zu jedem Projekt eine Bankverbindung für weitere Spenden angegeben werden. Diese Bankverbindung sehen Sie dann direkt auf der Detailseite des Projektes. Falls es einmal keine Bankdaten geben sollte, sind zu jedem Projekt auch Kontaktdaten angegeben. Wenn Ihnen ein Projekt besonders am Herzen liegt, freut sich der Projektträger sehr, wenn Sie sich persönlich melden!</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Wie kann ich mich über den Status meiner unterstützten Projekte informieren?</h2>
                        <div slot="body">
                            <p>Gehen Sie einfach auf unserer Aktionsseite und suchen Sie nach Ihrem gewünschten Projekt. Über die Statusleiste erkennen Sie sofort, wie viel des Betrages schon gespendet wurde.</p>
                        </div>
                    </collapsible>
                    <h3>Projekt einreichen und Spenden erhalten
                        <br>
                        <em>Sie haben ein Projekt, das unsere Unterstützung benötigt?</em>
                    </h3>
                    <collapsible>
                        <h2 class="h5">Wie lege ich mein eigenes Projekt an?</h2>
                        <div slot="body">
                            <p>
                                Interessenten können auf der Aktionsseite einen schriftlichen Antrag auf
                                Förderung im Rahmen der Initiative Velbert zeigt Herz stellen: Orientieren
                                Sie sich dafür am orange-farbenen Bereich, dort werden Sie automatisch
                                durch alle Schritte geführt. Die Pflichtfelder des Teilnahmeformulars sind
                                komplett auszufüllen. Die im Anmeldeprozess eingegebenen Vereinsdaten
                                können nachträglich nicht verändert oder ergänzt werden.
                            </p>
                            <p>Es gelten die Nutzungsbedingungen der Aktionsseite.</p>
                            <p>
                                Wenn das Projekt durch die Stadtwerke Velbert freigegeben wurde, erscheint
                                es nach kurzer Rücksprache mit dem Ansprechpartner des Projektes auf der
                                Aktionsseite.
                            </p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Wie kann ich mit meinem sozialen Projekt teilnehmen?</h2>
                        <div slot="body">
                            <p>
                                Auf der Aktionsseite finden gemeinnützige Organisationen und Vereine eine
                                regionale Plattform, um Ihre sozialen Projekte und den konkreten
                                Unterstützungsbedarf vorzustellen. Die Teilnahme ist kostenlos! Um Ihr
                                Projekt zu präsentieren, klicken Sie einfach auf
                                <em>Projekt einreichen</em>und dann geht es los!
                                <br>
                            </p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Gibt es einen Maximalbetrag pro Projekt?</h2>
                        <div slot="body">
                            <p>Ja, dieser beträgt aktuell 500 € pro Projekt.</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Wie lange kann mein Projekt unterstützt werden?</h2>
                        <div slot="body">
                            <p>Jedes Projekt hat die Chance, bis zu 5 Monaten die erforderlichen Herzen zu sammeln.</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Bekomme ich das gesammelte Förderbudget auf jeden Fall immer ausgezahlt, auch wenn noch nicht das Spendenziel erreicht ist?</h2>
                        <div slot="body">
                            <p>Sobald der gesammelte Förderbetrag 10 Euro übersteigt, wird der innerhalb der 5 Monate andauernden Förderperiode gesammelte Spendenbetrag ausgezahlt.
                                <br>Diese bedeutet: Das Förderbudget kann zwischen 10 € und 500 € liegen.
                            </p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Welche Vorgaben muss ein Projekt erfüllen, um die Chance auf Förderung zu erhalten?</h2>
                        <div slot="body">
                            <ul>
                                <li>
                                    Das Projekt ist im Versorgungsgebiet der Stadtwerke Velbert
                                    angesiedelt.
                                </li>
                                <li>
                                    Den Schwerpunkt bildet die Förderung von lokalen, gemeinnützigen
                                    Organisationen und Veranstaltungen mit nachhaltiger Zielsetzung und
                                    regionaler Ausrichtung.
                                </li>
                                <li>
                                    Maßnahmen, Veranstaltungen, Feste und Projekte mit kulturellen,
                                    ökologischen, sozialen, sportlichen und wissenschaftlichen Bezügen, die
                                    von der Stadt Velbert oder ihren Einrichtungen oder von privaten
                                    gemeinnützigen Initiativen durchgeführt werden
                                </li>
                                <li>Veranstaltungen der Brauchtumspflege</li>
                                <li>
                                    Sportvereine (mit Profi-Abteilung ausschließlich im Rahmen von
                                    Sponsoring, keine Spenden)
                                </li>
                                <li>
                                    Das Projekt muss 2019 im Versorgungsgebiet der Stadtwerke stattgefunden
                                    haben oder dort im Jahr 2019 bzw. Dezember 2018 starten.
                                </li>
                                <li>
                                    Projekte, die bereits von den Stadtwerken unterstützt werden, können
                                    nicht teilnehmen (keine Doppelförderung).
                                </li>
                                <li>
                                    Maßgebend für die Förderung sind die Reihenfolge der Anmeldung und die
                                    Freigabe durch die Stadtwerke Velbert.
                                </li>
                            </ul>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Wann darf ein Projekt nicht teilnehmen?</h2>
                        <div slot="body">
                            <p>Von der Förderung ausgeschlossen sind:</p>
                            <ul>
                                <li>
                                    Politische Parteien, parteinahe Organisationen, Gewerkschaften, Amts-
                                    und Mandatsträger, Bewerber um ein öffentliches Amt
                                </li>
                                <li>
                                    Projekte oder Einrichtungen, die gegen die guten Sitten verstoßen, die
                                    einen extremen politischen Hintergrund haben, sowie Anfragen, die von
                                    politisch extremen oder fremdenfeindlichen Gruppen eingereicht werden
                                </li>
                                <li>
                                    Sportarten und Tätigkeiten, bei denen Gewaltverherrlichung im
                                    Vordergrund steht
                                </li>
                                <li>
                                    Religiöse Bewegungen, Einrichtungen, Kirchengemeinden (Ausnahme:
                                    Karitative Einrichtungen, soweit die Glaubensverkündung nicht im
                                    Mittelpunkt steht, z.B. Kindergärten in Trägerschaft der Kirche)
                                </li>
                                <li>
                                    Projekte jedweder Art, die politisch oder gesellschaftlich umstritten
                                    sind.
                                </li>
                                <li>Charity Clubs</li>
                                <li>
                                    Spenden und Sponsoring aufgrund einer besonderen Nähe von
                                    Organmitgliedern oder Mitarbeitern zu Führungsgremien von
                                    Fördermittelempfängern
                                </li>
                                <li>Spenden an Einzelpersonen</li>
                                <li>Spenden an Organisationen mit kommerziellen Abteilungen</li>
                            </ul>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Sind die Projekte auf der Plattform vertrauenswürdig?</h2>
                        <div slot="body">
                            <p>Die Qualität, Transparenz und Ernsthaftigkeit der Projekte sind uns sehr wichtig. Deshalb wird jedes Projekt auch individuell von den Stadtwerken geprüft. Dabei orientieren sich die Entscheider in erster Linie an den Vorgaben, die ein Projekt erfüllen muss.</p>
                        </div>
                    </collapsible>
                    <collapsible>
                        <h2 class="h5">Wann und warum wird die Initiative ausgesetzt?</h2>
                        <div slot="body">
                            <p>Die Stadtwerke Velbert behalten sich das Recht vor, die gesamte Initiative oder auch nur Teile davon jederzeit zu ändern, ganz oder zeitweise auszusetzen oder zu beenden, insbesondere, wenn eine ordnungsgemäße Durchführung der Aktion aus technischen oder rechtlichen Gründen nicht mehr gewährleistet ist.</p>
                        </div>
                    </collapsible>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import Collapsible from '@/elements/Collapsible'
export default {
    name: 'PageFaq',

    components: {
        Collapsible
    }
}
</script>



// WEBPACK FOOTER //
// src/components/PageFaq.vue